import { RecordList, type RecordSlotProps } from '@databink/web/extension';

/**
 * `crm.lead.detail.tabs`: the sample dashboards built for a lead, with what each cost. The
 * demo itself (its report, and the price for in-person runs) opens from the list.
 */
export function LeadDemos({ record }: RecordSlotProps) {
  return (
    <div className="space-y-3">
      <p className="max-w-2xl text-sm text-slate-600">
        The website form builds a demo for every lead that asks. The discovery report on each demo
        is for you only. The demo itself is deleted 7 days after it was asked for; open it and
        choose Build the demo again for a new link. What its run wrote is deleted after 90 days,
        unless the lead becomes a client.
      </p>
      <RecordList
        entity="ext.demo_request"
        query={{
          filter: [{ field: 'lead_id', op: 'eq', value: record.id }],
          sort: { field: 'created_at', dir: 'desc' },
        }}
        columns={[
          'website',
          'source',
          'asked_on',
          'last_opened_at',
          'days_opened',
          'cost',
          'state',
        ]}
        empty="No demos"
      />
    </div>
  );
}
